export default __webpack_public_path__ + "static/media/btn_google_light_normal_ios.45446013.svg";